function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106 106",
    style: {
      enableBackground: "new 0 0 106 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#e4e4e4"
    },
    cx: 53,
    cy: 53,
    r: 53
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f4f4f4"
    },
    d: "M83.3 35.2v35.6c0 2.3-1.9 4.2-4.2 4.2h-52c-2.3 0-4.2-1.9-4.2-4.2V35.2c0-2.3 1.9-4.2 4.2-4.2h52c2.4 0 4.2 1.9 4.2 4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M83.3 35.2v3.2c0 1.1-.9 2-2 2.1-21.8 1.1-38.9 14.2-46 33.1-.3.8-1.1 1.4-2 1.3h-6.2c-2.3 0-4.1-1.9-4.1-4.2V35.2c0-2.3 1.9-4.2 4.2-4.2h52c2.3 0 4.1 1.9 4.1 4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#595959"
    },
    d: "M23 40.4h60.3v8.8H23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8d8d8d"
    },
    d: "M81.9 40.4c-1.3.4-14.1-.2-27.5 8.8H23v-8.8h58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#979797"
    },
    d: "M40.2 60h-8.7c-.6 0-1-.5-1-1s.5-1 1-1h8.7c.6 0 1 .5 1 1s-.5 1-1 1zM40.2 66.5h-8.7c-.6 0-1-.5-1-1s.5-1 1-1h8.7c.6 0 1 .5 1 1s-.5 1-1 1z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.2f50603ce67dc0d4f5063f37db4de62c.svg";
export { ForwardRef as ReactComponent };